// extracted by mini-css-extract-plugin
module.exports = {"energy":"Bios_energy_3FlLl","energyTitle":"Bios_energyTitle_34dfc","energySubtitle":"Bios_energySubtitle_1rtfj"};